import { Link } from "@/src/i18n/navigation";
import { useLocale } from "next-intl";

export interface VirtualTourProps {
  title: string;
  description: string;
  types: {
    id: string;
    text: string;
    link: string;
  }[];
}

export default function VirtualTour(props: VirtualTourProps) {
  const lang = useLocale()
  
  return (
    <div className="relative bg-[url('/homepage/virtual-tour.jpg')] bg-cover bg-no-repeat">
      <div className="grid place-items-center w-full py-12 xl:py-40">
        <div className="w-full xl:max-w-screen-xl mx-auto flex flex-col justify-center items-center z-[1]">
          <h1
            className="text-white text-center font-pluto xl:text-6xl"
            dangerouslySetInnerHTML={{ __html: props.title }}
          ></h1>
          <h2
            className="text-white text-center text-[13px] xl:text-3xl break-words my-2 xl:my-4 mx-9 xl:mx-0"
            dangerouslySetInnerHTML={{ __html: props.description }}
          ></h2>

          <div className="inline-flex space-x-3 xl:space-x-6 mt-3 xl:mt-6">
            {props.types.map((type) => (
              <Link locale={lang} prefetch key={type.id} href={type.link}>
                <button className="hover:bg-gold hover:text-white bg-[rgba(0,0,0,.25)] text-gold text-[12px] xl:text-2xl px-3 xl:px-10 py-1 xl:py-2 border xl:border-[2px] border-gold rounded-[3.3rem] font-pluto cursor-pointer">
                  {type.text}
                </button>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
